var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionSectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.113)",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21 1.575c-4.2 0-7.593 3.379-7.593 7.56l.002.191a7.698 7.698 0 001.369 4.15l.009.01.002.023-1.395 3.276 3.323-1.404-.077-.051c1.317.901 2.777 1.365 4.36 1.365 4.2 0 7.592-3.378 7.592-7.56 0-4.181-3.392-7.56-7.592-7.56zm0 .72c3.8 0 6.868 3.056 6.868 6.84 0 3.785-3.069 6.84-6.868 6.84l-.195-.002a6.825 6.825 0 01-3.59-1.127l-.08-.053-.01-.016a.433.433 0 00-.212-.152.586.586 0 00-.221-.028l-.05.005a.47.47 0 00-.29.143l-.01.013-1.583.668.757-1.775v-.073c0-.086-.003-.14-.015-.212l-.013-.066a.602.602 0 00-.11-.232l-.01-.01.007.01a6.966 6.966 0 01-1.244-3.933c0-3.784 3.069-6.84 6.869-6.84z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.222 11.519c-.154 0-.307-.153-.307-.306V9.454c0-.153.153-.305.307-.305a1.7 1.7 0 001.689-1.682 1.7 1.7 0 00-1.69-1.683 1.7 1.7 0 00-1.688 1.683c0 .152-.154.305-.307.305-.154 0-.308-.153-.308-.305 0-1.3 1.075-2.37 2.38-2.37 1.306 0 2.38 1.07 2.38 2.37A2.31 2.31 0 019.682 9.76v1.453c-.153.153-.307.306-.46.306z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.283,
    cy: 12.825,
    r: 1
  }))));
}

export default SvgQuestionSectionIcon;